import { SlotType } from '@sparelabs/domain-logic'
import { IPoint } from '@sparelabs/geography'
import { IListModelQueryParamValues, IModelJsonValues } from '@sparelabs/http-client-utils'
import { IDriverBreakReasonResponse } from './DriverBreakReasonTypes'

export enum DriverBehaviourType {
  LatePullout = 'latePullout',
  Offline = 'offline',
  ProlongedStop = 'prolongedStop',
  UnexpectedStop = 'unexpectedStop',
  IdleOutsideServiceZone = 'idleOutsideServiceZone',
}

export const PROLONGED_STOP_TYPES = [SlotType.Pickup, SlotType.Dropoff, SlotType.RouteStop] as const

export type DriverBehaviourProlongedStopType = (typeof PROLONGED_STOP_TYPES)[number]

export const isDriverBehaviourProlongedStopType = (type: unknown): type is DriverBehaviourProlongedStopType =>
  type != null &&
  Object.values(SlotType).includes(type as SlotType) &&
  PROLONGED_STOP_TYPES.includes(type as DriverBehaviourProlongedStopType)

export interface IDriverBehaviourResponse extends IModelJsonValues {
  type: DriverBehaviourType
  dutyId: string
  driverId: string
  startTs: number
  startLocation: IPoint | null
  endTs: number | null
  endLocation: IPoint | null
  delayTs: number | null
  dismissedAtTs: number | null
  prolongedStopType?: DriverBehaviourProlongedStopType | null
  reasonId: string | null
  notes: string | null
}

export interface IDriverBehaviourListQueryParams extends IListModelQueryParamValues {
  dutyId?: string[]
  driverId?: string[]
  providerId?: string[]
  type?: DriverBehaviourType[]
  reasonId?: string[]
  inProgress?: boolean
}

export type IDriverBehaviourPatchBody = Partial<Pick<IDriverBehaviourResponse, 'dismissedAtTs' | 'reasonId' | 'notes'>>

export interface IDriverBehaviourWithBreakReason extends IDriverBehaviourResponse {
  driverBreakReason: Pick<IDriverBreakReasonResponse, 'id' | 'type'> | null
}
